(function() {
	angular
		.module('main')
		.controller('CalendarSettingsController', CalendarSettingsController);

	CalendarSettingsController.$inject = [];

	function CalendarSettingsController() {}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/calendarSettingsController.js